import { create } from 'zustand';

export interface PageContext {
  route?: string;
  projectKey?: string;
  itemKey?: string;
  sprintId?: string;
  boardId?: string;
  releaseId?: string;
  buildId?: string;
  noteId?: string;
  documentId?: string;
}

interface UiState {
  assistantOpen: boolean;
  toggleAssistant(open?: boolean): void;
  assistantPrompt: string | null;
  askAssistant(prompt: string): void;
  clearPrompt(): void;
  pageContext: PageContext;
  setPageContext(ctx: PageContext): void;
  create: { open: boolean; projectKey?: string; type?: string; defaults?: Record<string, unknown> };
  openCreate(opts?: { projectKey?: string; type?: string; defaults?: Record<string, unknown> }): void;
  closeCreate(): void;
  palette: boolean;
  setPalette(open: boolean): void;
}

/** Local UI state (Zustand, §14): panels, dialogs, page context for the Assistant (FR-AI-31). */
export const useUi = create<UiState>((set) => ({
  assistantOpen: false,
  toggleAssistant: (open) => set((s) => ({ assistantOpen: open ?? !s.assistantOpen })),
  assistantPrompt: null,
  askAssistant: (prompt) => set({ assistantOpen: true, assistantPrompt: prompt }),
  clearPrompt: () => set({ assistantPrompt: null }),
  pageContext: {},
  setPageContext: (pageContext) => set({ pageContext }),
  create: { open: false },
  openCreate: (opts = {}) => set({ create: { open: true, ...opts } }),
  closeCreate: () => set({ create: { open: false } }),
  palette: false,
  setPalette: (palette) => set({ palette }),
}));
